<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <h1 class="title">Proyectos</h1>
      </div>
      <div class="column">
        <div class="buttons">
          <button class="button is-link" @click="addProyect">
            <span class="icon is-small">
              <span class="material-icons"> add_circle_outline </span>
            </span>
            <span>Crear Proyecto</span>
          </button>
        </div>
      </div>
    </div>
    <div v-show="showform" class="box">
      <h1 class="title is-5">
        {{ projectToSave._id ? "Editar proyecto" : "Crear nuevo proyecto " }}
      </h1>
      <div class="columns is-multiline">
        <div class="column is-6">
          <label class="label">Empresa</label>
          <div class="field has-addons">
            <div class="control">
              <button class="button is-primary" @click="search">
                <span class="material-icons"> search </span>
              </button>
            </div>
            <div class="control is-expanded">
              <input
                v-model="projectToSave.nnit"
                class="input"
                type="text"
                placeholder="Cliente"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Nombre del proyecto</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="projectToSave.name"
                placeholder="Nombre del proyecto"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Descripción del pryecto</label>
            <div class="control">
              <textarea
                v-model="projectToSave.descripcion"
                class="textarea"
                placeholder="Descripción"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <div class="buttons">
          <button class="button is-link" @click="saveProyect">
            <span class="icon is-small">
              <span class="material-icons"> save </span>
            </span>
            <span>Guardar</span>
          </button>
          <button class="button is-dark" @click="cancel">
            <span class="icon is-small">
              <span class="material-icons"> cancel </span>
            </span>
            <span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Empresa</th>
          <th>Proyecto</th>
          <th>Fecha</th>
          <th>Activo</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in projects" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            {{ item.empresaproject.nit | textnumber() }}
            {{ item.empresaproject.name }}
          </td>
          <td>
            {{ item.name }}
          </td>
          <td>{{ item.created | dateletra() }}</td>
          <td>{{ item.active ? "Sí" : "No" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showform: false,
      projectToSave: {
        _id: null,
        name: null,
        nnit: null,
        empresaproject: null,
        descripcion: null,
      },
      empresas: [],
      projects: [],
    };
  },
  computed: {
    ...mapState(["resultDatamodal"]),
  },
  methods: {
    async saveProyect() {
      try {
        if (!this.projectToSave.empresaproject) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una empresa.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.projectToSave.name) {
          this.$store.dispatch("notify", {
            message: "Debe indicar un nombre para el proyecto.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        await apiServices.post(`/addproject`, this.projectToSave);
        this.$store.dispatch("notify", {
          message: "Proyecto guardado con éxito.",
          type: "is-success",
          position: "top-center",
        });
        this.cancel();
        await this.findProjects();
      } catch (err) {
        console.log(err);
      }
    },
    async findProjects() {
      try {
        const result = await apiServices.get(`/projectlistall`);
        if (result.data) {
          this.projects = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    addProyect() {
      this.projectToSave = {
        _id: null,
        name: null,
        nnit: null,
        empresa: null,
        descripcion: null,
      };
      this.showform = true;
    },
    cancel() {
      this.projectToSave = {
        _id: null,
        name: null,
        nnit: null,
        empresa: null,
        descripcion: null,
      };
      this.showform = false;
    },
    search() {
      const dataempresas = this.empresas.map((e) => {
        const d = {
          codigo: e.nit,
          nombre: e.name,
          id: e._id,
          selected: false,
        };
        return d;
      });
      this.$store.commit("launchModal", {
        title: "Seleccione la empresa",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Nit" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: dataempresas,
        result: "empresas",
      });
    },
    async findCompanys() {
      try {
        const result = await apiServices.get(`/getEmpresaProject`);
        this.empresas = result.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    resultDatamodal(nv, ov) {
      if (nv) {
        if (nv.result === "empresas") {
          this.projectToSave.nnit = `${nv.data.codigo} - ${nv.data.nombre}`;
          this.projectToSave.empresaproject = nv.data.id;
        }
      }
    },
  },
  created() {
    this.findCompanys();
    this.findProjects();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/proyectos/configuracion/Proyectos.vue